module.exports = dependencies['@wh/ui-translations']['0.4.6']['module'];